(() => {
  // Prevent multiple bindings if the script is loaded more than once (Shopify sections, etc.)
  if (window.__customATCInit) return;
  window.__customATCInit = true;

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(".custom-add-to-cart-btn");
      if (!btn) return;

      // Per-button lock to avoid double fire
      if (btn.disabled || btn.dataset.busy === "1") return;
      btn.dataset.busy = "1";
      btn.disabled = true;

      const label = btn.querySelector(".add-to-cart-label");
      const prevText = label ? label.textContent : null;

      const showAddedThenReset = () => {
        if (label) label.textContent = "Dodano do koszyka";
        btn.classList.add("added");

        setTimeout(() => {
          if (label && prevText != null) label.textContent = prevText;
          btn.classList.remove("added");
          btn.disabled = false;
          delete btn.dataset.busy;
        }, 1000);
      };

      const failReset = () => {
        btn.disabled = false;
        delete btn.dataset.busy;
      };

      // Prefer the theme’s AJAX form if it exists
      const productTile = btn.closest(".product-tile");
      const form = productTile?.querySelector(".add-to-cart-form");

      if (form && typeof form.requestSubmit === "function") {
        try {
          form.requestSubmit(); // Let the theme handle cart + notification
          showAddedThenReset();
        } catch (err) {
          failReset();
          console.error("ATC form submit failed:", err);
        }
        return;
      }

      // Fallback: direct AJAX to Shopify endpoint
      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) {
        console.warn("No data-variant-id on button; cannot add to cart.");
        failReset();
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => {
          if (!res.ok) throw new Error("Błąd dodawania do koszyka");
          return res.json();
        })
        .then(() => {
          // If your theme uses <cart-notification>, refresh its sections
          const cartNotification = document.querySelector("cart-notification");
          if (cartNotification) {
            fetch("/?sections=cart-notification,cart-notification-count")
              .then((r) => r.json())
              .then((sections) => {
                if (typeof cartNotification.renderContents === "function") {
                  cartNotification.renderContents({ sections });
                } else if (typeof cartNotification.open === "function") {
                  cartNotification.open();
                }
              })
              .catch((err) =>
                console.warn("Cart notification refresh failed:", err)
              );
          }
          showAddedThenReset();
        })
        .catch((err) => {
          console.error(err);
          failReset();
        });
    },
    // passive to play nice with scroll/touch; we prevent duplicates with our own locks
    { passive: true }
  );
})();


